var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m480 135.5v241c0 19.05-15.45 34.5-34.5 34.5h-375c-19.05 0-34.5-15.45-34.5-34.5v-241c0-10.72 4.89-20.29 12.56-26.62l11.44 1.12 200 190 200-190 2.67-4.43c10.36 5.96 17.33 17.13 17.33 29.93z",
    fill: "#414A56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m462.67 105.57-2.67 4.43-200 190-200-190-11.44-1.12c5.96-4.92 13.61-7.88 21.94-7.88h375c6.25 0 12.11 1.66 17.17 4.57z",
    fill: "#57606F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m445.5 421h-375c-24.538 0-44.5-19.963-44.5-44.5v-241c0-13.325 5.903-25.838 16.195-34.333 7.942-6.556 17.994-10.167 28.305-10.167h375c7.781 0 15.442 2.041 22.155 5.901 13.783 7.929 22.345 22.719 22.345 38.599v241c0 24.537-19.963 44.5-44.5 44.5zm-375-310c-5.675 0-11.206 1.986-15.574 5.592-5.673 4.682-8.926 11.574-8.926 18.908v241c0 13.51 10.991 24.5 24.5 24.5h375c13.51 0 24.5-10.99 24.5-24.5v-241c0-8.745-4.72-16.892-12.316-21.262-3.683-2.118-7.897-3.238-12.184-3.238h-375z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m260 310c-2.479 0-4.958-0.917-6.888-2.75l-200-190c-4.004-3.804-4.166-10.133-0.362-14.138 3.804-4.003 10.133-4.165 14.138-0.362l193.11 183.46 193.11-183.46c4.005-3.804 10.335-3.641 14.138 0.362 3.804 4.004 3.642 10.334-0.362 14.138l-200 190c-1.93 1.833-4.409 2.75-6.888 2.75z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.e16ef1279ed3d03f0d990cf5ca9d3f33.svg";
export { ForwardRef as ReactComponent };